import { render, staticRenderFns } from "./Pendiente.vue?vue&type=template&id=dc4cdad0&"
import script from "./Pendiente.vue?vue&type=script&lang=js&"
export * from "./Pendiente.vue?vue&type=script&lang=js&"
import style0 from "./Pendiente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports